import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { logout, LOGOUTAtive } from "./auth";

const initialState = {
  loading: false,
  error: null,
  data: [], // To store fetched data
};

// Create the slice
const authGameSlice = createSlice({
  name: "getData",
  initialState,
  reducers: {
    // Start request
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    // Request success
    fetchSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },

    // Request failure
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateGame: (state, action) => {
      const gameIndex = state.data.usergames.findIndex(
        (game) => game._id === action.payload._id
      );
      if (gameIndex !== -1) {
        state.data.usergames[gameIndex] = {
          ...state.data.usergames[gameIndex],
          ...action.payload,
        };
      }
    },
  },
});

// Actions
export const { requestStart, fetchSuccess, requestFailure, updateGame } =
  authGameSlice.actions;

// Thunk for GET request
export const getGData = () => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(`/private/games`);
    if (response?.status === 200) {
      dispatch(fetchSuccess(response.data));

      // toast.success("Data fetched successfully!");
    } else {
      if (response.data == null) {
        // dispatch(logout());
        dispatch(LOGOUTAtive());
      }
      throw new Error("Failed to fetch data.");
    }
  } catch (err) {
    const errorMessage =
      err?.response?.data?.message || err.message || "Something went wrong!";
    toast.error(errorMessage);
    dispatch(requestFailure(errorMessage));
  }
};

export default authGameSlice.reducer;
